const TIMEOUT_ERROR = "TimeoutError";

/**
 * Rejette si la promesse n'a pas abouti dans le délai, sans l'interrompre : elle peut encore
 * se terminer en arrière-plan. Sert aux appels qui retardent l'affichage du BO.
 */
export const withTimeout = (promise, delayMs) => {
  let timer;

  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      const error = new Error(`timeout_${delayMs}ms`);
      error.name = TIMEOUT_ERROR;
      reject(error);
    }, delayMs);
  });

  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};

export const isTimeout = (error) => error?.name === TIMEOUT_ERROR;